<template>
	<Modal
		width="800px"
	>
		<template #modal-title>
			Test Decryption
		</template>
		<template #modal-title-action>
			<IconButton @click="handleClose">
				mdi-close
			</IconButton>
		</template>
		<template #modal-content>
			<p class="mb-4">
				Paste an encrypted value below to verify it can be decrypted using the selected encryption key.
			</p>
			<TextField
				v-model="encryptedText"
				label="Encrypted Value *"
				placeholder="Paste encrypted value here"
				:disabled="isLoading"
				rules="required"
			/>
			<div
				v-if="result"
				class="mt-4"
			>
				<Message
					:type="result.success ? 'success' : 'error'"
				>
					<template v-if="result.success">
						<strong>
							Decryption successful!
						</strong>
						<br>
						<div style="word-break: break-all; overflow-wrap: break-word;">
							Decrypted value: {{ result.decryptedText }}
						</div>
					</template>
					<template v-else>
						<strong>
							Decryption failed
						</strong>
						<br>
						{{ result.error || 'Unable to decrypt the provided value' }}
					</template>
				</Message>
			</div>
		</template>
		<template #modal-footer>
			<SecondaryActionButton
				:disabled="isLoading"
				@click="handleClose"
			>
				Close
			</SecondaryActionButton>
			<PrimaryActionButton
				:disabled="!encryptedText || isLoading"
				:loading="isLoading"
				@click="onTest"
			>
				Test Decryption
			</PrimaryActionButton>
		</template>
	</Modal>
</template>

<script>
import Modal from '../../../../../shared/components/modal.vue'
import TextField from '../../../../../shared/components/text-field.vue'
import Message from '../../../../../shared/components/message.vue'
import PrimaryActionButton from '../../../../../shared/components/primary-action-button.vue'
import SecondaryActionButton from '../../../../../shared/components/secondary-action-button.vue'
import { testEncryption } from '../../../../../shared/utils/api/encryption-keys.js'
import IconButton from '../../../../../shared/components/icon-button.vue'

export default {
	name: 'encryption-test-dialog',

	components: {
		Modal,
		TextField,
		Message,
		PrimaryActionButton,
		SecondaryActionButton,
		IconButton
	},

	props: {
		show: {
			type: Boolean,
			default: false
		},
		encryptionKeyId: {
			type: Number,
			required: true
		},
		encryptionTypeId: {
			type: Number,
			default: 1
		}
	},

	data () {
		return {
			encryptedText: '',
			isLoading: false,
			result: null
		}
	},

	watch: {
		show (newVal) {
			if (newVal) {
				this.reset()
			}
		}
	},

	methods: {
		reset () {
			this.encryptedText = ''
			this.result = null
			this.isLoading = false
		},
		handleClose () {
			this.$emit('close')
		},
		async onTest () {
			this.isLoading = true
			this.result = null

			try {
				const response = await testEncryption({
					encryptionKeyId: this.encryptionKeyId,
					encryptionTypeId: this.encryptionTypeId,
					encryptedText: this.encryptedText
				})
				this.result = response
			} catch (error) {
				let errorMsg = 'An error occurred during decryption'
				if (error.response?.status === 400) {
					errorMsg = error.response?.data?.errorMessage || 'Could not decrypt the provided value'
				}
				this.result = {
					success: false,
					error: errorMsg
				}
			} finally {
				this.isLoading = false
			}
		}
	}
}
</script>
